import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, map, Observable, throwError } from "rxjs";
import { EstadosVM } from "src/app/api/model/city/estado/estadoVM";
import { AppConfigurationService } from "../../../erp/services/base/appConfiguration.service";
import { PMEVM } from "../../model/pme/pmeVM";
 
@Injectable({
  providedIn: "root",
})
export class PMEService {
  constructor(
    private httpClient: HttpClient,
    private appConfigurationService: AppConfigurationService

  ) {}

  // Json
  onReceberCotacao(dados: PMEVM): Observable<any> {
    return this.httpClient.post<any>(`${this.appConfigurationService.cotacaoOnline}/SimuladorPlena`, dados)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((err) => {
          return throwError(() => new Error(err));
        })
      );
  }
  

  // FormData
  // onReceberCotacao(formData: FormData): Observable<any> {
  //   return this.httpClient.post<any>(`${this.appConfigurationService.cotacaoOnline}/SimuladorPlena`, formData)
  //     .pipe(
  //       map((response) => {
  //         return response;
  //       }),
  //       catchError((err) => {
  //         return throwError(() => new Error(err));
  //       })
  //     );
  // }
 

  ListStates(): Observable<EstadosVM> {
    return this.httpClient
      .get<EstadosVM>(
        `${this.appConfigurationService.cotacaoOnline}/CarregaEstados`
      )
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((err) => {
          return throwError(() => new Error(err || "Erro no servidor"));
        })
      );
  }

  ListCitiesByStates(id: any[]): Observable<any> {
    return this.httpClient
      .post<any>(
        `${this.appConfigurationService.cotacaoOnline}/CarregaCidades?idEstado=${id}`,
        id
      )
      .pipe(
        map((response) => {
          return response;
        }),

        catchError((err) => {
          return throwError(() => new Error(err));
        })
      );
  }
}
